// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"05b42cbf","455":"bc958bfe"}[chunkId] + ".chunk.js";
};